<template>
    <div>
        <div class="route-step-indicator mb-4 fs-5">
            <div class="route-step-descrip text-center text-primary fw-bold" v-html="title"></div>

            <div id="route-step-dot" class="d-flex justify-content-center route-step-dot fs-4 my-2">
                <i class="fa-solid fa-chevron-left text-primary me-3 cursor-pointer" @click="backStep"></i>
                <div @click="goStep(1)" :class="step >= 1 ? 'active' : ''" class="step-dot cursor-pointer dot-1"></div>
                <div @click="goStep(2)" :class="step >= 2 ? 'active' : ''" class="step-dot cursor-pointer dot-2"></div>
                <div @click="goStep(3)" :class="step == 3 ? 'active' : ''" class="step-dot cursor-pointer dot-3"></div>

                <i class="fa-solid fa-chevron-right text-primary ms-3 cursor-pointer" @click="nextStep"></i>
            </div>
        </div>

        <!---------- PASO 1 ---------->
        <div :class="step == 1 ? 'active' : 'd-none'" class="route-step-one">
            <form action="" class="route-creation">
                <div class="row">
                    <!-- <div class="col-md-3">
                        <div class="form-group">
                            <select
                                type="text"
                                class="form-control"
                                id="route-select-category"
                            >
                                <option value="cat">Categoría</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <select
                                type="text"
                                class="form-control"
                                id="route-select-level"
                            >
                                <option value="level">Nivel</option>
                            </select>
                        </div>
                    </div> -->
                    <div class="col-md-3">
                        <div class="form-group border border-dark rounded-8 d-flex align-items-center form-search">
                            <input @keyup.prevent="filterRutas" v-on:keydown.enter.prevent="" type="text"
                                class="form-control border-0 rounded-8" placeholder="Busca la ruta de aprendizaje" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <select name="company-filter" id="period-filter" class="form-control px-3 border-dark rounded-8"
                            @change="filtrarPorCategoria($event)">
                            <option value="all" disabled selected>Todas las categorías</option>
                            <option v-for="r of dessertsCategories" :key="r.term_id" :value="r.term_id">
                                {{ r.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <b class="d-block pt-2">Mostrando {{ cantidadTotal }} rutas en total. </b>
                    </div>
                </div>
            </form>

            <div class="row mb-4">
                <div class="col-md-4" v-for="ruta of rutas" :key="ruta.id">
                    <div class="card rounded-8 overflow-hidden shadow" style="height: auto">
                        <h5 class="card-title bg-green text-light p-2 mb-0 line-height d-flex gap-3 align-items-center">
                            <div class="card-title-icon">
                                <i class="fa-solid fa-medal fa-2x"></i>
                            </div>
                            <div class="card-title-info small">
                                <span>{{ ruta.name }}</span>
                            </div>
                        </h5>
                        <div class="card-body lh-sm text-dark">
                            <div class="short-description-diploma">
                                <p>
                                    {{ ruta.description }}
                                </p>
                            </div>
                            <div class="container-count-info-diplomat fw-bold mb-2">
                                <i class="fa-solid fa-book-open text-secondary"></i>
                                4 a 6 cursos&nbsp;|&nbsp;
                                <i class="fa-solid fa-clock text-secondary"></i>
                                6 a 10 horas
                            </div>

                            <ul class="text-dark small list-courses-description">
                                <li v-for="(curso, index) of ruta.courses" :key="'else' + index">
                                    <a href="jasvascript:void(0);"><span class="text-dark"
                                            :title="curso.post_content.replace(/<\/?[^>]+(>|$)/g, '')">{{ curso.post_title
                                            }}</span></a>
                                    <!--<i class="fa fa-info-circle" style="display: inline-block;" aria-hidden="true" :title="curso.post_content.replace(/<\/?[^>]+(>|$)/g, '')"></i>-->
                                </li>
                            </ul>
                        </div>

                        <div class="card-footer border-0 text-center mb-3 bg-white">
                            <a type="button"
                                class="card-link text-dark fw-bold rounded-8 border border-secondary w-auto py-2 px-4"
                                @click="changePaso(2, ruta)">Inscribir ruta</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!---------- PASO 2 ---------->
        <div :class="step == 2 ? 'active' : 'd-none'" class="route-step-two">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-5">
                        <p class="border border-dark rounded-8 d-flex align-items-center form-search p-0">
                            <input type="text" class="form-control border-0 rounded-8" placeholder="Busca tu estudiante"
                                @keyup="filterEstudiantes" />
                        </p>
                    </div>
                    <div class="col-md-2">
                        <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox"
                                v-model="showFilters"> Mostrar Filtros</label>
                    </div>
                    <div v-if="empresas.length > 0" class="col-md-5">
                        <div class="form-group">
                            <!-- <label for="empresa">Seleccionar empresa</label> -->
                            <select name="empresa" id="empresa" class="form-control p-2" v-model="empresaSelected"
                                @change="changeUrl">
                                <option value="">
                                    Seleccionar empresa para la asignación de
                                    Usuarios y ruta
                                </option>
                                <option v-for="(client, index) of empresas" :key="index" :value="client">
                                    {{ client.client }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-students-select table-responsive">
                <table class="table table-sm text-center align-middle mt-3 small">
                    <thead class="">
                        <tr>
                            <th scope="col">
                                <span class="text-primary fw-bold">
                                    ({{ this.userselected.length }}/{{
                                        this.users.length
                                    }})
                                </span>
                                <input v-model="isCheckedSelectAll" class="form-check-input" @change="selectAll" type="checkbox"/>
                            </th>
                            <th scope="col">
                                <span class="d-block text-center">Nombres</span>
                            </th>
                            <th scope="col">
                                <span class="d-block text-center">Apellidos</span>
                            </th>
                            <th scope="col">
                                <span class="d-block text-center">Email</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Rol</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Cargo</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Nivel del cargo</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Área de trabajo</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Fecha de registro</span>
                            </th>
                            <th scope="col">
                                <span class="text-center">Último inicio de sesión</span>
                            </th>
                        </tr>
                        <tr v-show="showFilters">
                            <td colspan="1"></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.firstname" placeholder="Ingrese nombre" title="Ingrese nombre"></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.lastname" placeholder="Ingrese apellido" title="Ingrese apellido"></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.client" placeholder="Ingrese email" title="Ingrese email"></td>
                            <td><select class="form-control" @change="searchData($event)" placeholder="Seleccione.." v-model="busqueda.role">
                                    <option value="">Todos</option>
                                    <option value="SU">SU</option>
                                    <option value="Estudiante">Estudiante</option>
                                    <option value="admin">Admin</option>
                                </select></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.cargo" placeholder="Ingrese cargo" title="Ingrese cargo"></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.nivel_cargo" placeholder="Ingrese nivel cargo" title="Ingrese nivel cargo"></td>
                            <td><input type="text" class="form-control" @input="searchData($event)" v-model="busqueda.area_trabajo" placeholder="Ingrese area de trabajo" title="Ingrese area de trabajo"></td>
                            <td colspan="2"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user of users" :key="user.id">
                            <td>
                                <div class="">
                                    <div class="form-check">
                                        <input v-model="userselected" class="form-check-input inputUser" type="checkbox"
                                            :value="user.id" :id="'checkStudent' + user.id" @click="checkEmpresaSelected" />
                                    </div>
                                </div>
                            </td>
                            <td>
                                <label class="form-check-label d-flex" :for="'checkStudent' + user.id">
                                    <div class="student-info text-start">
                                        <p class="m-0 small">
                                            {{ user.firstname }}
                                        </p>
                                    </div>
                                </label>
                            </td>
                            <td>
                                <p class="m-0 small">{{ user.lastname }}</p>
                            </td>
                            <td>
                                <p class="m-0 small"><small>{{ user.email }}</small></p>
                            </td>
                            <td>{{ user.role }}</td>
                            <td>{{ user.position }}</td>
                            <td>{{ user.level }}</td>
                            <td>{{ user.area }}</td>
                            <td>{{ format_date(user.created_at) }}</td>
                            <td>
                                <div class="text-success" style="width: 100px;">{{ user.last_connection_user ?
                                    format_date(user.last_connection_user) : '-' }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row mb-3">
                <div class="col-md-7">
                    <div class="pager small justify-content-start">
                        <small>Mostrando {{ this.users.length ? this.users.length : 0 }} resultados de {{ this.users.length
                            ?
                            this.users.length : 0 }}</small>

                        <a href="#">
                            <div class="totop">
                                <i class="fa fa-chevron-up text-primary" aria-hidden="true"></i>
                                Arriba
                            </div>
                        </a>
                        <div class="pager-count">Pagina {{ this.users.length > 0 ? '1' : '0' }}</div>
                        <a href="javascript:void(0)">
                            <div class="next">
                                <i class="fa fa-chevron-right text-primary" aria-hidden="true"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-5">
                    <button class="btn btn-primary py-1 px-2 mx-2 mt-3 w-100 rounded-8 fs-5 fw-bold" @click="changePaso(3)">
                        Inscribir Usuarios esta ruta
                    </button>
                </div>
            </div>
        </div>

        <!---------- PASO 3 ----------->
        <div :class="step == 3 ? 'active' : 'd-none'" class="route-step-three">
            <div class="row">
                <div class="col-md-6">
                    <div class="card rounded-8 overflow-hidden shadow w-75 m-auto">
                        <h5 class="card-title bg-green text-light p-2 mb-0 line-height d-flex gap-3 align-items-center">
                            <div class="card-title-icon">
                                <i class="fa-solid fa-medal fa-2x"></i>
                            </div>
                            <div class="card-title-info small">
                                <span>{{ show.name }}</span>
                            </div>
                        </h5>
                        <div class="card-body lh-sm text-dark">
                            <div class="short-description-diploma">
                                <p>
                                    {{ show.description }}
                                </p>
                            </div>
                            <div class="container-count-info-diplomat fw-bold mb-2">
                                <i class="fa-solid fa-book-open text-secondary"></i>
                                4 a 6 cursos&nbsp;|&nbsp;
                                <i class="fa-solid fa-clock text-secondary"></i>
                                6 a 10 horas
                            </div>
                            <ul class="text-dark small">
                                <li v-for="(curso, index) of show.courses" :key="'else' + index">
                                    <a href="jasvascript:void(0);"><span>{{ curso.post_title }}</span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <h5 class="text-dark fw-bold">Ruta seleccionada</h5>
                    <p class="text-dark">
                        {{ show.name }}
                        <a href="javascript:void(0);" @click.prevent="changePaso(1)"><i
                                class="fa-regular fa-pen-to-square text-primary fs-3 ms-2"></i></a>
                    </p>
                    <br />
                    <h5 class="text-dark fw-bold">
                        Usuarios Inscritos: {{ userselected.length }}
                        <a href="javascript:void(0);" @click.prevent="changePaso(2)"><i
                                class="fa-regular fa-pen-to-square text-primary fs-3 ms-2"></i></a>
                    </h5>
                </div>
            </div>

            <button class="btn btn-primary py-3 px-4 ms-auto mb-4 d-block rounded-8 fs-5 fw-bold" @click="agregarRuta">
                Inscribir esta ruta
            </button>
        </div>

        <!-- modal confirmar -->
        <div class="modal fade" id="confirmarInscribir" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="confirmarInscribirLabel" aria-hidden="true">
            <div v-if="show" class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center fs-4 text-dark lh-sm">
                            Vas a inscribir la ruta
                            <br />
                            <b>{{ show.name }}</b>
                            <br />
                            ¿Estás seguro?
                        </div>
                    </div>
                    <div class="modal-footer border-0 text-center d-flex justify-content-between">
                        <button class="btn btn-inverted px-4">Cancelar</button>
                        <button id="pasar" class="btn btn-primary px-4" @click="agregarRuta">
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirmación -->
        <button id="succesBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            data-bs-target="#succesModal">
        </button>
        <div class="modal fade" id="succesModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesModalLabel">
                            Crear
                        </h5>
                    </div>
                    <div class="modal-body text-center">
                        Se ha creado<br>la ruta correctamente.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light" data-bs-dismiss="modal"
                            @click="redirectTo()">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: ["routes", "students", "get", "redirect", "empresas", "categoryroutes", "categorysearch"],
    created() {
        this.getCategories();

    },
    mounted() {
        this.getRutas();
    },
    data() {
        return {
            title: "Paso 1: Selecciona Ruta",
            step: 1,
            cantidadTotal: 0,
            rutas: [],
            timeout: [],
            timeoutEst: [],
            dessertsCategories: [],
            show: [],
            routeCourse: [],
            users: [],
            userselected: [],
            empresaSelected: "",
            showFilters: false,
            busqueda: { firstname: "", lastname: "", email: "", role: "", cargo: "", nivel_cargo: "", area_trabajo: "" },
            isCheckedSelectAll: false,
        };
    },
    methods: {
        getCategories() {
            axios.get(this.categoryroutes).then((res) => {
                this.dessertsCategories = res.data;
            });
        },
        getRutas() {
            axios.get(this.routes).then((res) => {
                this.rutas = res.data.data;
                this.cantidadTotal = res.data.cantidad_total;
            });
        },
        getEstudiantes() {
            let url = this.students;
            if (this.empresaSelected) {
                url = this.empresaSelected.users;
            }
            let alerta = this.$swal({ title: 'Cargando usuarios', showConfirmButton: false, allowOutsideClick: false });
            axios.get(url + "?onlyByClient=true").then((res) => {
                this.users = res.data;
                alerta.close();
            });
        },
        getCursoRutas() {
            if (this.rutas.length > 0) {
                this.rutas.forEach(async (e) => {
                    await axios
                        .get(this.routes + "/curso/" + e.id)
                        .then((res) => {
                            this.routeCourse[e.id] = res.data;
                        });
                });
            }
        },
        getCurso(id) {
            axios.get(this.routes + "/curso/" + id).then((res) => {
                this.routeCourse = res.data;
            });
        },
        inscribirRuta(ruta) {
            this.show = ruta;
            this.getCursoRutas(this.show.id);
        },
        async filterRutas(event) {
            clearTimeout(this.timeout);
            let rutas = [];
            setTimeout(async () => {
                this.rutas = await axios.get(this.routes).then((res) => {
                    let filtrador = [];
                    let rutas = res.data.data;
                    rutas.forEach((e, k) => {
                        if (e.name) {
                            if (
                                e.name
                                    .toLowerCase()
                                    .indexOf(event.target.value.toLowerCase()) >
                                -1
                            )
                                filtrador.push(e);
                        }
                    });
                    return filtrador;
                });
            }, 1000);
            this.getCursoRutas();
        },
        filterEstudiantes(event) {
            clearTimeout(this.timeoutEst);

            this.timeoutEst = setTimeout(() => {
                let url = this.students;
                if (this.empresaSelected) {
                    url = this.empresaSelected.users + "?onlyByClient=true";
                }
                axios.get(url).then((res) => {
                    let filtrador = [];
                    this.users = res.data;
                    this.users.forEach((e, k) => {
                        if (e.firstname) {
                            if (
                                e.firstname
                                    .toLowerCase()
                                    .indexOf(event.target.value.toLowerCase()) >
                                -1
                            ) {
                                filtrador.push(e);
                                return;
                            }
                        }
                        if (e.lastname) {
                            if (
                                e.lastname
                                    .toLowerCase()
                                    .indexOf(event.target.value.toLowerCase()) >
                                -1
                            ) {
                                filtrador.push(e);
                                return;
                            }
                        }
                    });
                    this.users = filtrador;
                });
            }, 1000);
        },
        agregarRuta() {
            let url = this.get + "?suggest=true";
            let succesBtn = document.getElementById("succesBtn");
            if (this.empresaSelected) {
                url = this.empresaSelected.routes + "?suggest=true";
            }
            this.show.students = this.userselected;
            axios.post(url, this.show).then((res) => {
                succesBtn.click();
            });
        },
        redirectTo() {
            window.location.href = this.redirect;
        },
        changePaso(step, ruta = null) {
            if (ruta) this.show = ruta;
            switch (step) {
                case 1:
                    this.title = "Paso 1: Selecciona Ruta";
                    this.step = step;
                    break;
                case 2:

                    this.title =
                        "Paso 2: Selecciona usuarios para tu ruta: <b>" +
                        this.show.name +
                        "</b>";
                    this.step = step;
                    if (this.users.length == 0) this.getEstudiantes();
                    break;
                case 3:
                    this.title =
                        "Paso 2: Selecciona Usuarios para tu ruta: <b>" +
                        this.show.name +
                        "</b>";
                    this.step = step;
                    break;
            }
        },

        format_date(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY");
            }
        },
        checkEmpresaSelected() {
            if (this.empresas.length > 0 && !this.empresaSelected) {
                this.$swal("Debe seleccionar una empresa para continuar").then(
                    (res) => {
                        document.getElementById("empresa").focus();
                        this.userselected = [];
                    }
                );
            }
        },
        changeUrl() {
            console.log(this.empresaSelected);
            this.users = [];
            this.userselected = [];
            this.getEstudiantes();
        },
        filtrarPorCategoria(val) {
            const value = val.target.value;
            axios.get(`${this.categorysearch}/${value}`).then((res) => {
                this.rutas = res.data.data;
                this.cantidadTotal = res.data.cantidad_total;
            });
        },
        nextStep() {
            const vm = this
            if (vm.step < 3) {
                vm.step++
            }
        },
        backStep() {
            const vm = this
            if (vm.step > 1) {
                vm.step--
            }
        },
        goStep(step) {
            const vm = this
            vm.step = step
        },
        searchData(event) {
            this.userselected = [];
            this.isCheckedSelectAll = false;
            let url = this.students;
            if (this.empresaSelected) {
                url = this.empresaSelected.users;
            }
            let alerta = this.$swal({ title: 'Cargando usuarios', showConfirmButton: false, allowOutsideClick: false });
            let search = ``;//`&search=${event}`;
            let searchByName = this.busqueda.firstname != "" ? `&firstname=${this.busqueda.firstname}` : ``;
            let searchByLastName = this.busqueda.lastname != "" ? `&lastname=${this.busqueda.lastname}` : ``;
            let searchByEmail = this.busqueda.email != "" ? `&email=${this.busqueda.email}` : ``;
            let searchByRole = this.busqueda.role != "" ? `&rol=${this.busqueda.role}` : ``;
            let searchByCargo = this.busqueda.cargo != "" ? `&cargo=${this.busqueda.cargo}` : ``;
            let searchByNivelCargo = this.busqueda.nivel_cargo != "" ? `&nivel_cargo=${this.busqueda.nivel_cargo}` : ``;
            let searchByAreaTrabajo = this.busqueda.area_trabajo != "" ? `&area_trabajo=${this.busqueda.area_trabajo}` : ``;
            let filters = searchByName + searchByLastName + searchByRole + searchByCargo + searchByEmail + searchByNivelCargo + searchByAreaTrabajo ;
            axios
                .get(
                    `${url}?onlyByClient=true${search}${filters}`
                )
                .then((res) => {
                    this.users = res.data;
                    alerta.close();
                });
        },
        selectAll(){
            this.userselected = [];
            let ids = document.getElementsByClassName("inputUser");
            for(let i=0;i<ids.length;i++){
                if((this.isCheckedSelectAll && ids[i].disabled == false) || (ids[i].disabled && ids[i].checked)){
                    this.userselected.push(ids[i].value);
                }
            }
        },
    },
};
</script>
<style>
/*Functional Styling*/
@media (pointer: coarse),
(hover: none) {
    [title] {
        position: relative;
        display: flex;
        justify-content: center;
    }

    [title]:focus::after {
        content: attr(title);
        position: absolute;
        top: 90%;
        color: #000;
        background-color: #fff;
        border: 1px solid;
        width: fit-content;
        padding: 3px;
    }

}</style>